import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './hooks/useAuth';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
     <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);


// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import { AuthProvider } from './hooks/useAuth';

// const rootElement = document.getElementById('root');

// // Check if the app was pre-rendered by react-snap
// if (rootElement.hasChildNodes()) {
//   // Hydrate instead of render if content exists (pre-rendered by react-snap)
//   ReactDOM.hydrateRoot(
//     rootElement,
//     <React.StrictMode>
//       <AuthProvider>
//         <App />
//       </AuthProvider>
//     </React.StrictMode>
//   );
// } else {
//   // Normal render for development
//   const root = ReactDOM.createRoot(rootElement);
//   root.render(
//     <React.StrictMode>
//       <AuthProvider>
//         <App />
//       </AuthProvider>
//     </React.StrictMode>
//   );
// }